import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import FileOpenIcon from "@mui/icons-material/FileOpen";
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import SquareIcon from "@mui/icons-material/Square";
import { Grid, Typography, useTheme } from "@mui/material";
import { StyledEstablecimientos } from '../../../../styled/Prevencion';

const AyudaLabelEstablecimientoDetalle = () => {
  const theme = useTheme();

  return (
    <>
      <Grid container spacing={2} direction="column" sx={{ marginTop: 1 }}>
        <Grid container item spacing={2} xs={12} nowrap="true">
          <StyledEstablecimientos.GridRowItem item xs={4}>
            <StyledEstablecimientos.GridItemAligned component={SquareIcon}
              sx={{ color: theme.palette.senary.dark }}
            />
            <Typography>
              El área de prevención está verificando la presentación
            </Typography>
          </StyledEstablecimientos.GridRowItem>
          <StyledEstablecimientos.GridRowItem item xs={3}>
            <StyledEstablecimientos.GridItemAligned component={SquareIcon}/>
            <Typography>Formulario con estado finalizado</Typography>
          </StyledEstablecimientos.GridRowItem>
          <StyledEstablecimientos.GridRowItem item xs={3}>
            <StyledEstablecimientos.GridItemAligned component={NoteAltOutlinedIcon}
              sx={{ color: theme.palette.senary.light }}
            />
            <Typography>Editar Formulario</Typography>
          </StyledEstablecimientos.GridRowItem>
          <StyledEstablecimientos.GridRowItem item xs={1}>

          </StyledEstablecimientos.GridRowItem>
        </Grid>
        <Grid container item spacing={2} xs={12} nowrap="true">
          <StyledEstablecimientos.GridRowItem item xs={4}>
            <StyledEstablecimientos.GridItemAligned component={FileOpenIcon}
              sx={{ color: theme.palette.secondary.light }}
            />
            <Typography>Visualizar formulario</Typography>
          </StyledEstablecimientos.GridRowItem>
          <StyledEstablecimientos.GridRowItem item xs={5}>
            <StyledEstablecimientos.GridItemAligned component={BookmarkBorderOutlinedIcon}
              sx={{ color: `${theme.palette.quartary.light}` }}
            />
            <Typography>Certificado de presentación</Typography>
          </StyledEstablecimientos.GridRowItem>
          <StyledEstablecimientos.GridRowItem item xs={3}>
          </StyledEstablecimientos.GridRowItem>
        </Grid>
      </Grid>
    </>
  );
};

export default AyudaLabelEstablecimientoDetalle;
